import { DropdownFilter } from "../../../js/molecules/dropdownFilter";

DropdownFilter(".js-dropdown-filter-blog");
